import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../assets/css/categoryList.css';
import Breadcrumb from '../Component/Layout/Breadcrumb';
import SearchFilter from '../Component/Layout/Searchlist';
import MobileFilter from '../Component/Layout/MobileFilter/MobileFilter';
import FilterDesktop from '../Component/Layout/Filter/FilterDesktop';
import ProductShorting from '../Component/Common/ProductShorting';

import p1 from '../../src/assets/images/img/hd-1.webp'
import p2 from '../../src/assets/images/img/hd-2.webp'
import p3 from '../../src/assets/images/img/hd-3.webp'
import p4 from '../../src/assets/images/img/hd-4.webp'
import p5 from '../../src/assets/images/img/hd-5.webp'
import p6 from '../../src/assets/images/img/hd-6.webp'
import p7 from '../../src/assets/images/img/hd-7.webp'
import p8 from '../../src/assets/images/img/hd-8.webp'


const Homedecor = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      // Replace this with your actual data fetching logic
      const fetchedProducts = Array.from({ length: 6 }).map((_, index) => (
        
        {
        id: index,
        name: 'AGUA ACRYLIC TABLE WASTE BIN',
        image:
          'https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcQ_qJSQioStBP6_5S1Pe8cvLfBP2XuAbAKbYJwRKxkixrlpx1iyv8IvOcK3JPv7mMTUA97eau3qRVabB12YGb0zJ2A72y1z4umJqyxZQhbJ',
        }
      
      ));
      setProducts(fetchedProducts);
      setLoading(false);
    }, 2000); // Simulate a 2-second loading time
  }, []);

  return (
    <>
    <Breadcrumb />
      <section className="category-List">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-lg-3 col-md-3 col-sm-6 col-12 min-Width">
              <h3 style={{ fontSize: '14px', color: '#676464' }} className="FILTER-DESKTOP">
                Filter
              </h3>
              <div className="FILTER-DESKTOP">
                <FilterAllProduct />
              </div>
            </div> */}

            <div className="col-lg-12 col-md-12 col-sm-6 col-12">
              <div className="row">
                <div className="col-md-3 col-4 col-md-minwidth col-md-minwidth-ss001">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>  
                  <div className="FILTER-MOBILE">
                    <MobileFilter />
                   </div> 
                  </div>
                </div>

                <div className="col-md-4 col-5 text-end">
                  <p style={{ textAlign: 'left', color: 'rgb(127 127 127)', marginBottom: "0", marginTop: "2px", fontSize: "14px", }}>
                        Showing {products.length} items
                      </p>
                </div>

                <div className="col-md-5 col-5 col-md-news-right001">
                 <div className='d-Fles-Rto' style={{ justifyContent: "flex-end" }}> 
                      <SearchFilter /> 
                      <ProductShorting/> 
                 </div>
                </div>

              </div>
              <div className="row">
                 <div className='col-md-3 col-md-minwidth col-md-minwidth-ss'> 
                   <FilterDesktop/>
                 </div>
                 <div className='col-md-9 col-md-minwidth-left'>
                  <div className='row'>
                {/* {loading
                  ? Array.from({ length: 6 }).map((_, index) => (
                      <div key={index} className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="border-1 p-0 mt-1">
                          <Skeleton height={200} style={{ borderRadius: '2px' }} />
                          <div className="text-center mt-1">
                            <Skeleton width={`80%`} />
                          </div>
                        </div>
                      </div>
                    ))

                  : products.map((product) => ( */}

                      <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p1} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                            Attractive Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p2} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                           Ceramic Vase
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p3} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                           Couples Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p4} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                           Elephant Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p5} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                            Horse Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                               <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p6} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                            Horse Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                                <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p7} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                            Owl Showpiece
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                                <div  className="col-lg-3 col-md-3 col-sm-6 col-6">

                                <div className="latest-items latest-items2">
                                  <div className="properties">
                                    <div className="properties-card">
                                      <div className="properties-img">
                                        <Link to="/ProductDetails" target='_blank'> 
                                        <img src={p8} alt=""  style={{ borderRadius: '2px' }} />
                                        </Link>
                                        <span className="like-heart">
                                          <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                            <i id="fa-heart-21262" className="fa fa-heart-o" />
                                          </a>
                                        </span>
                                      </div>
                                      <div className="properties-caption properties-caption2">
                                        <h3>
                                          <Link to="/ProductDetails" target="_blank" >
                                            Wooden Vase
                                         </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          
                          
                           
                      </div>
                     </div>
                 </div> 
              </div>
           </div>
        </div>
      </section>
    </>
  );
};
export default Homedecor;
